import axios from "axios";


export const fetchWardApiCall = (body) => {
    return axios.get(`https://arogyanxtdevapi.fundaclear.in/api/Ward`);
  };

  export const postWardApiCall = (body) => {
    return axios.post(`https://arogyanxtdevapi.fundaclear.in/api/Ward`, body);
  };